import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},_vm._l((_vm.MapQueryLayer_Layers_Select),function(item,index){return _c(VCard,{key:index,attrs:{"loading":item.IsLoading}},[_c(VCardTitle,{staticClass:"pa-1 ml-2 mt-1 text-subtitle-1"},[_vm._v(_vm._s(item.Label))]),_c(VCardText,{staticClass:"pa-1",domProps:{"innerHTML":_vm._s(item.Resut)}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }